import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      icons: {
        alert: 'mdi-alert',

        todos: {
          todo: 'mdi-marker',
          notChecked: 'mdi-checkbox-blank-circle-outline',
          checked: 'mdi-checkbox-marked-circle',
          needsApproval: 'mdi-progress-check',
          comments: {
            send: 'mdi-send'
          }
        },

        arrows: {
          left: 'mdi-chevron-left',
          right: 'mdi-chevron-right',
          top: 'mdi-chevron-up',
          down: 'mdi-chevron-down',
          menu: {
            top: 'mdi-menu-up',
            down: 'mdi-menu-down'
          }
        },
        navigation: {
          download: 'mdi-download',
          dashboard: 'mdi-view-dashboard',
          lockout: 'mdi-exit-run',
          showSDPSitemap: 'mdi-sitemap',
          meta: 'mdi-information',
          text: 'mdi-textbox'
        },
        zinc: 'mdi-shield-outline',
        key: 'mdi-key',
        stars: {
          normal: 'mdi-star',
          outlined: 'mdi-star-outline'
        },
        edit: 'mdi-database-edit',
        addContent: 'mdi-plus-circle',
        undo: 'mdi-undo',
        search: 'mdi-database-search',
        filter: 'mdi-filter',
        sort: 'mdi-sort',
        information: 'mdi-information-variant',
        selectAll: 'mdi-select-all',
        cancel: 'mdi-cancel',
        asPdf: 'mdi-pdf-box',
        dragHandleVertical: 'mdi-drag-vertical',
        dragHandleHorizontal: 'mdi-drag-horizontal',
        close: 'mdi-close',
        ok: 'mdi-hand-okay',
        interaction: 'mdi-gesture-double-tap',
        comment: 'mdi-comment-plus',
        done: 'mdi-hand-okay',
        star: 'mdi-star',
        checkout: 'mdi-play',
        link: 'mdi-link',
        more: 'mdi-dots-vertical',
        add: 'mdi-plus',
        format: {
          uppercase: 'mdi-format-letter-case-upper',
          lowercase: 'mdi-format-letter-case-lower',
          normal: 'mdi-format-letter-case'
        },
        trash: {
          toTrash: 'mdi-trash-can',
          fromTrash: 'mdi-delete-restore'
        },
        archive: {
          toArchive: 'mdi-package-down',
          fromArchive: 'mdi-package-up'
        },
        downloadAsset: 'mdi-file-download',
        restore: 'mdi-restore',
        references: 'mdi-library-books',
        sync: 'mdi-sync',
        showAsset: 'mdi-information-outline'
      }
    };
  }
});
